import {
  Component,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { ResetPassword } from '../store/auth.actions';
import { ActivatedRoute } from '@angular/router';
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: 'reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
  form: FormGroup;
  resetToken: string;
  showPassword: boolean;
  private stopper: Subject<void> = new Subject<void>();

  constructor(
    private fb: FormBuilder,
    private store: Store<AppState>,
    private route: ActivatedRoute,
  ) {
    this.showPassword = false;
    this.form = this.fb.group({
      password: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(
            "(?=.*?[#?!@$%^&*-]).{6,}"
          )
        ])
      ],
      confirmpwd: [
        '',
        Validators.compose([
          Validators.required,
        ]),
      ],
    }, {
      validator: MustMatch('password', 'confirmpwd'),
    });
  }

  ngOnInit() {
    this.route.params.pipe(takeUntil(this.stopper)).subscribe(params => {
      this.resetToken = params.token;
    });
  }

  resetPassword() {
    if (this.form.invalid) {
      return false;
    }
    const password = this.form.get('password').value;
    this.store.dispatch(new ResetPassword(password, this.resetToken));
  }

  ngOnDestroy() {
    this.stopper.next();
    this.stopper.complete();
  }

  showPasswordFunction() {
    this.showPassword = !this.showPassword;
  }

  fieldMatcher(field: string, errorKey: string) {
    return function (control: FormControl): { [s: string]: boolean } {
      if (!control.parent) return null;
      return control.parent.get(field).value === control.value
        ? null
        : { [errorKey]: true };
    };
  }

  restrictSpace(event: KeyboardEvent) {
    let x = event.keyCode;
    if (x == 32) {
      return false;
    }
  }
}

export function MustMatch(controlName: string, matchingControlName: string) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];

    if (matchingControl.errors && !matchingControl.errors.mustMatch) {
      // return if another validator has already found an error on the matchingControl
      return;
    }

    // set error on matchingControl if validation fails
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ mustMatch: true });
    } else {
      matchingControl.setErrors(null);
    }
  }
}